import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/apiClient";
import Navbar from "@/components/Navbar";
import TheField from "@/components/TheField";
import { Badge } from "@/components/ui/badge";
import { Lock, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function Dating() {
  const [scenarios, setScenarios] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { api.get("/practice/scenarios").then((r) => setScenarios(r.data.filter((s) => s.category === "Dating"))).catch(() => {}); }, []);

  const open = (s) => { if (s.locked) { toast.error(`Practise ${s.unlock_after} conversations to unlock.`); return; } navigate(`/practice/${s.id}`); };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="relative grain overflow-hidden">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 py-14 grid lg:grid-cols-2 gap-10 items-center relative z-10">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }}>
            <p className="text-xs uppercase tracking-[0.2em] text-primary mb-3">Dating</p>
            <h1 className="font-serif text-4xl sm:text-6xl leading-tight mb-5">Be yourself<br />around someone<br /><span className="italic text-primary">you really like.</span></h1>
            <p className="text-muted-foreground max-w-md">No lines. No games. No trying to be more impressive. Just you — grounded, present, and comfortable being seen.</p>
          </motion.div>
          <div className="flex justify-center"><TheField intensity={0.8} size={340} /></div>
        </div>
      </div>

      <main className="max-w-6xl mx-auto px-5 sm:px-8 pb-16">
        <h2 className="font-serif text-2xl mb-4">Practise</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {scenarios.map((s, i) => (
            <motion.button key={s.id} initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}
              onClick={() => open(s)} data-testid={`dating-${s.id}`}
              className={`group text-left rounded-2xl border border-border p-6 transition-all duration-300 ${s.locked ? "opacity-60" : "hover:border-primary/40 hover:-translate-y-1"}`}>
              <div className="flex items-center justify-between mb-6"><Badge variant="secondary" className="text-xs">{s.difficulty}</Badge>{s.locked && <Lock className="w-4 h-4 text-muted-foreground" />}</div>
              <h3 className="font-serif text-2xl mb-1">{s.title}</h3>
              <p className="text-sm text-muted-foreground mb-4">{s.tagline}</p>
              <span className="inline-flex items-center gap-1 text-sm text-primary">{s.locked ? `Unlocks at ${s.unlock_after}` : <>Begin <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" /></>}</span>
            </motion.button>
          ))}
        </div>
      </main>
    </div>
  );
}
